import React, { useMemo } from "react";
import { DrivingDetailData } from "../../type";
import InfoDisplay, {
  InfoDisplayColumn,
} from "../../../../../../components/InfoDisplay";
import SubTitle from "../SubTitle";
import { DRIVING_ORDER_TYPE, SUB_ORDER_STATUS } from "../../constants";
import styles from "./index.module.scss";

interface PropsType {
  detailData: DrivingDetailData;
}

/**
 * 服务信息
 * @param props
 * @returns
 */
const ServiceInfo = (props: PropsType) => {
  const { detailData } = props;

  // 是否是取车单
  const isGetCarOrder = useMemo(
    () =>
      String(detailData?.drivingOrderType) === String(DRIVING_ORDER_TYPE.get),
    [detailData],
  );

  const columns = useMemo(() => {
    return [
      {
        title: "开始时间",
        dataIndex: "serviceTime",
        type: "time",
        dateFormat: "YYYY/MM/DD HH:mm",
        visible: !isGetCarOrder,
      },
      {
        title: "司机姓名",
        dataIndex: "driverName",
      },
      {
        title: "司机电话",
        dataIndex: "driverPhone",
        render: (text) =>
          !!text ? (
            <a style={{ color: "#8CB654" }} href={`tel:${text}`}>
              {text}
            </a>
          ) : (
            ""
          ),
      },
      {
        title: "预约取车时间",
        dataIndex: "serviceTime",
        type: "time",
        dateFormat: "YYYY/MM/DD HH:mm",
        visible: isGetCarOrder,
      },
      {
        title: "门店电话",
        dataIndex: "shopTel",
        render: (text) =>
          !!text ? (
            <a style={{ color: "#8CB654" }} href={`tel:${text}`}>
              {text}
            </a>
          ) : (
            ""
          ),
        visible: !isGetCarOrder,
      },
      {
        title: "还车验证码",
        dataIndex: "verifyCode",
        visible: !isGetCarOrder,
      },
      {
        title: isGetCarOrder ? "取车照片" : "还车照片",
        dataIndex: "photoList",
        type: "image",
        // photoList: [
        //   "https://ecmb.bdimg.com/tam-ogel/90099454_298257915_1920_1440.jpg",
        //   "https://ecmb.bdimg.com/tam-ogel/90099454_298257915_1920_1440.jpg",
        //   "https://ecmb.bdimg.com/tam-ogel/90099454_298257915_1920_1440.jpg",
        //   "https://ecmb.bdimg.com/tam-ogel/90099454_298257915_1920_1440.jpg",
        // ],
        // 订单状态为【行驶途中、司机到达目的地、已收车、订单已完成】时显示
        visible:
          Array.isArray(detailData?.photoList) &&
          !!detailData?.photoList?.length &&
          [
            SUB_ORDER_STATUS.driving,
            SUB_ORDER_STATUS.arrived,
            SUB_ORDER_STATUS.received,
            SUB_ORDER_STATUS.completed,
          ].includes(Number(detailData?.subOrderStatus)),
      },
    ] as InfoDisplayColumn[];
  }, [detailData, isGetCarOrder]);

  return (
    <div className={styles.detailInfo}>
      <SubTitle>{isGetCarOrder ? "取车服务" : "送车服务"}</SubTitle>
      <InfoDisplay columns={columns} dataSource={detailData} />
    </div>
  );
};

export default ServiceInfo;
